// Third-party imports
import React from 'react';
import {
  InfiniteList,
} from 'react-admin';

// Local imports - components
import RepairListToolbar from './RepairListToolbar';
import RepairDataTable from './RepairDataTable';
import { useTitle } from '@src/hooks/useTitle';

const RepairsList = () => {
  const { title } = useTitle('Repair Management');

  return (
    <InfiniteList
      perPage={25}
      sort={{ field: 'dateUpdated', order: 'DESC' }}
      title={title}
      actions={false}
    >
      <RepairListToolbar />
      <RepairDataTable />
    </InfiniteList>
  );
};

export default RepairsList;
